import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from '../../hooks/useForm';
import isEmail from 'validator/lib/isEmail';
import { esborrarErrorAction, crearErrorAction } from '../../actions/ui.js';
import { useTranslation } from 'react-i18next';
import { iniciarPeticioLoginAsincronaAxios } from '../../actions/auth';
import axios from 'axios';

export const LoginDropdown = () => {
    const dispatch = useDispatch();
    const { loading, msgError } = useSelector(s => s.ui);
    const { auth }  = useSelector(s => s);
    const [t]       = useTranslation('generic');
    const navegacio = useNavigate();

    React.useEffect(() => {
        if (auth.tokenJwt !== undefined) navegacio('/');
    }, [auth]);

    const [loginOpen,     setLoginOpen]     = useState(false);
    const [passwordShown, setPasswordShown] = useState(false);
    const [msgError2,     setMsgError2]     = useState(false);

    const [modalOlvidat, setModalOlvidat] = useState(false);
    const [emailOlvidat, setEmailOlvidat] = useState('');
    const [enviando,     setEnviando]     = useState(false);
    const [emailEnviado, setEmailEnviado] = useState(false);
    const [errorOlvidat, setErrorOlvidat] = useState('');

    const [formValues, handleInputChange] = useForm({ email: '', clau: '' });
    const { email, clau } = formValues;

    // Tancar drOpdown al clicar fora
    React.useEffect(() => {
        if (!loginOpen) return;
        const handler = (e) => {
            if (!e.target.closest('.ld-wrap')) setLoginOpen(false);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [loginOpen]);

    const isFormValid = () => {
        if (!email.trim() || !clau.trim()) {
            dispatch(crearErrorAction('Camps obligatoris')); setMsgError2(true); return false;
        }
        if (!isEmail(email)) {
            dispatch(crearErrorAction('Email incorrecto')); setMsgError2(true); return false;
        }
        setMsgError2(false); dispatch(esborrarErrorAction()); return true;
    };

    const handleLogin = (e) => {
        e.preventDefault();
        if (isFormValid()) { setMsgError2(true); dispatch(iniciarPeticioLoginAsincronaAxios(email, clau)); }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') { e.preventDefault(); handleLogin(e); }
    };

    const handleSolicitarReset = async (e) => {
        e.preventDefault();
        if (!isEmail(emailOlvidat)) { setErrorOlvidat('Introduce un email válido.'); return; }
        setErrorOlvidat(''); setEnviando(true);
        try {
            await axios.post(
                process.env.REACT_APP_DOMINI_API_CIUDAD + '/auth/solicitar-password',
                `email=${encodeURIComponent(emailOlvidat)}`,
                { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, withCredentials: true }
            );
            setEmailEnviado(true);
        } catch { setErrorOlvidat('Error al enviar. Inténtalo de nuevo.'); }
        finally { setEnviando(false); }
    };

    const abrirModalOlvidat = () => {
        setLoginOpen(false);
        setModalOlvidat(true);
        setEmailEnviado(false);
        setEmailOlvidat('');
        setErrorOlvidat('');
    };

    return (
        <>
        <div className="ld-wrap">
            <button
                className={`ld-trigger${loginOpen ? ' open' : ''}`}
                onClick={() => setLoginOpen(v => !v)}
            >
                Acceder
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M3 5l4 4 4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </button>

            {loginOpen && (
                <div className="ld-dropdown">
                    <h3 className="ld-title">Iniciar sesión</h3>
                    <p className="ld-desc">Accede con las credenciales de tu municipio.</p>

                    {msgError != null && msgError2 && (
                        <div className="ld-error">⚠ {msgError}</div>
                    )}

                    <div className="ld-field">
                        <label htmlFor="ldEmail">{t('login.txtEmail')}</label>
                        <input
                            id="ldEmail" type="email" name="email"
                            value={email} onChange={handleInputChange}
                            placeholder="correo@municipio.es"
                            className="ld-input" tabIndex={1} required
                        />
                    </div>

                    <div className="ld-field">
                        <label htmlFor="ldPassword">{t('login.txtClau')}</label>
                        <div className="ld-pass-wrap">
                            <input
                                id="ldPassword"
                                type={passwordShown ? 'text' : 'password'}
                                name="clau" value={clau}
                                onChange={handleInputChange}
                                onKeyDown={handleKeyPress}
                                placeholder="••••••••"
                                className="ld-input" tabIndex={2}
                                required minLength="8"
                            />
                            <button type="button" className="ld-pass-toggle" tabIndex={-1}
                                onClick={() => setPasswordShown(v => !v)}>
                                <i className={passwordShown ? 'bi-eye-slash' : 'bi-eye'} />
                            </button>
                        </div>
                    </div>

                    <div className="ld-row-forgot">
                        <button type="button" className="ld-forgot-btn" onClick={abrirModalOlvidat}>
                            ¿Olvidaste tu contraseña?
                        </button>
                    </div>

                    <button className="ld-btn" onClick={handleLogin} disabled={loading} tabIndex={3}>
                        {loading ? 'Verificando...' : t('login.btnIniciar')}
                    </button>
                </div>
            )}
        </div>

        {/* ── Modal OBLIT contraseña ── */}
        {modalOlvidat && (
            <div className="ld-modal-overlay">
                <div className="ld-modal">
                    <button 
            className="ld-modal-close-btn" 
            onClick={() => setModalOlvidat(false)}
            aria-label="Cerrar"
        >
            ✕
        </button>
                    {!emailEnviado ? (
                        <>
                            <h3 className="ld-modal-title">Recuperar contraseña</h3>
                            <p className="ld-modal-desc">
                                Introduce tu email y te enviaremos un enlace para crear una nueva contraseña.
                            </p>
                            {errorOlvidat && <div className="ld-modal-error">{errorOlvidat}</div>}
                            <div style={{ marginBottom: 4 }}>
                                <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 6 }}>
                                    Email
                                </label>
                                <input type="email" value={emailOlvidat}
                                    onChange={e => setEmailOlvidat(e.target.value)}
                                    onKeyDown={e => e.key === 'Enter' && handleSolicitarReset(e)}
                                    placeholder="tu@email.com" className="ld-modal-input" />
                            </div>
                            <div className="ld-modal-actions">
                                <button className="ld-modal-cancel" onClick={() => setModalOlvidat(false)}>Cancelar</button>
                                <button className="ld-modal-send" onClick={handleSolicitarReset} disabled={enviando}>
                                    {enviando ? 'Enviando...' : 'Enviar enlace'}
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            <div style={{ textAlign: 'center', marginBottom: 20, fontSize: 48 }}>📧</div>
                            <h3 className="ld-modal-title" style={{ textAlign: 'center' }}>Revisa tu email</h3>
                            <p className="ld-modal-desc" style={{ textAlign: 'center' }}>
                                Si <strong>{emailOlvidat}</strong> está registrado, recibirás un enlace
                                para restablecer tu contraseña. Válido 24 horas.
                            </p>
                            <button className="ld-modal-ok-btn" onClick={() => setModalOlvidat(false)}>
                                Entendido
                            </button>
                        </>
                    )}
                </div>
            </div>
        )}
        </>
    );
};